module.exports = {
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
        escapeValue: false // react already safes from xss
    },
    returnEmptyString: false,
    fallbackLng: "en",
    locales: ["en", "de", "fr", "it", "es", "pt"],
    react: {
      wait: true
    }
}
